import { prisma, TokenableModel, type Prisma } from "client";
import { flattenTicketWithBookableItem } from "../bookableItem/helpers";

export const generateToken = async (
  tokenableId: string,
  tokenableType: TokenableModel
) => {
  const verificationToken = await prisma.verificationToken.create({
    data: {
      tokenableId,
      tokenableType,
      expiresAt: new Date(new Date().getTime() + 7 * 24 * 60 * 60 * 1000), //one week
    },
  });

  return verificationToken;
};

export const expireToken = async (token: string) => {
  await prisma.verificationToken.update({
    where: { token },
    data: {
      expiresAt: new Date(),
    },
  });
};

export const getOrderFormVerificationToken = async (
  token: string,
  confirmation?: boolean,
  lang?: string
) => {
  try {
    let whereQuery: Prisma.VerificationTokenWhereInput = {};
    if (!confirmation) {
      whereQuery = { expiresAt: { gt: new Date() } };
    }

    const verificationToken = await prisma.verificationToken.findFirst({
      where: {
        token,
        tokenableType: TokenableModel.ORDER_ITEM, // Composite condition
        ...whereQuery,
      },
      include: {
        orderItem: {
          include: {
            order: {
              include: {
                formResults: {
                  include: {
                    formResult: {
                      include: {
                        formTemplate: true,
                      },
                    },
                  },
                },
                orderItems: {
                  include: {
                    ticket: {
                      include: {
                        // TODO: This is done for Backward compatibility with the old order items
                        bookableItem: {
                          include: {
                            formEntities: { include: { formTemplate: true } },
                            translations: lang
                              ? {
                                  where: {
                                    language: {
                                      code: lang,
                                    },
                                  },
                                }
                              : true,
                          },
                        },
                      },
                    },
                    invitationAttendee: {
                      include: {
                        invitation: {
                          include: {
                            formEntity: {
                              include: {
                                formTemplate: true,
                              },
                            },
                            translations: lang
                              ? {
                                  where: {
                                    language: {
                                      code: lang,
                                    },
                                  },
                                }
                              : true,
                          },
                        },
                      },
                    },
                    formResults: {
                      include: {
                        formResult: {
                          include: {
                            formTemplate: true,
                          },
                        },
                      },
                    },
                    entity: {
                      include: {
                        floorPlan: {
                          include: {
                            formEntities: {
                              include: {
                                formTemplate: true,
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
            entity: {
              include: {
                floorPlan: {
                  include: {
                    formEntities: {
                      include: {
                        formTemplate: true,
                      },
                    },
                  },
                },
              },
            },
          },
        },
      },
    });

    console.log(
      "Verification token found:",
      verificationToken?.orderItem?.order
    );
    if (!verificationToken) {
      return;
    }
    if (!verificationToken?.orderItem?.order) {
      console.error("Verification token not found.");
      throw new Error("Invalid or expired token.");
    }

    // TODO: This is done for Backward compatibility with the old order items
    // Flatten tickets and map invitation for backward compatibility
    const order = verificationToken.orderItem.order;
    return {
      ...order,
      orderItems: order.orderItems.map((item) => ({
        ...item,
        // Flatten ticket with bookableItem data
        ticket: item.ticket ? flattenTicketWithBookableItem(item.ticket) : null,
        // Map invitation from invitationAttendee for backward compatibility
        invitation: item.invitationAttendee?.invitation || null,
      })),
    };
  } catch (error) {
    console.error("Error generating token:", error);
    throw error;
  }
};
